import { FC } from 'react';

import { Partner } from 'types';

import DividendDocumentTableRow from './DividendDocumentTableRow';
import { useDividendDocumentModal } from '../context/DividendDocumentModalContext';

const DividendDocumentTableBody: FC = () => {
  const { data } = useDividendDocumentModal();

  const hasData = data.partners?.length > 0;

  return (
    <tbody>
      {hasData &&
        data.partners.map((partner: Partner, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr className="tb-tnx-item" key={`partner-dividend-${index}`}>
            <DividendDocumentTableRow index={index} partner={partner} />
          </tr>
        ))}
    </tbody>
  );
};

export default DividendDocumentTableBody;
